module.exports = __webpack_public_path__ + "img/quit_icon.f917cbf7.svg";